import Picobel from '../esm/Picobel';
// import helpers from '../esm/helpers';
// import 'picobel/css/player.default.css';

// console.log('file loaded');
let picobel_instance = Picobel({ theme: 'skeleton' });

console.log(picobel_instance.state);

// let slider = helpers.buildSlider('progress', 0, 100, 50);
// console.dir(slider.children[3]);

// let nodes = picobel_instance.findAudio(document);
// console.log(nodes);
// console.log(picobel_instance.state);
